// client-shared
import { storage } from '@goldblack/client-storage';

function setNavigation(props) {
    storage.transience.setState('main.containers', [props]);
}

function addNavigation(props) {
    storage.transience.addState('main.containers', props);
}

function removeNavigation() {
    storage.transience.popState('main.containers');
}

function pushNavigation(props) {
    const current = storage.transience.getValue('main.containers');
    storage.transience.setState('main.stack', current[0]);
    setNavigation(props);
}

function popNavigation() {
    const props = storage.transience.getValue('main.stack');
    setNavigation(props);
    storage.transience.setState('main.stack', null);
}

function createAdminProp() {
    const userSession = storage.transience.getValue('userSession');
    const config = storage.localStorage.getValue('config');
    return { path: 'admin', user: userSession, config: config?.data };
}

function createHomeProp() {
    const config = storage.localStorage.getValue('config');
    return { path: 'home', config: config?.data };
}

function createMessageProp() {
    const userSession = storage.transience.getValue('userSession');
    const config = storage.localStorage.getValue('config');
    return { path: 'chat', user: userSession, config: config?.data };
}

function createSettingProp() {
    const config = storage.localStorage.getValue('config');
    return { path: 'settings', config: config?.data };
}

function createExploreProp() {
    const config = storage.localStorage.getValue('config');
    return { path: 'explore', config: config?.data };
}

function createProfileProp(user) {
    const userSession = storage.transience.getValue('userSession');
    const config = storage.localStorage.getValue('config');
    return { path: 'profile', user: userSession, target: user, config: config?.data };
}

function createSearchProp() {
    const config = storage.localStorage.getValue('config');
    return { path: 'search', config: config?.data };
}

function createUserListProp(user, type, filters = null, title = null) {
    const config = storage.localStorage.getValue('config');
    return { path: 'userlist', user, type, filters, title, config: config?.data };
}

function createChatRoomProp(roomId, me, target) {
    const config = storage.localStorage.getValue('config');
    return { path: 'chatroom', roomId: roomId, user: me, target: target, config: config?.data };
}

function createTrendingProp() {
    const config = storage.localStorage.getValue('config');
    return { path: 'trending', config: config?.data };
}

function createLegalProp(props) {
    const config = storage.localStorage.getValue('config');
    return { path: 'legal', config: config?.data, ...props };
}

function createMessageComposeProp(target) {
    const userSession = storage.transience.getValue('userSession');
    const config = storage.localStorage.getValue('config');
    return { path: 'message-compose', user: userSession, target, config: config?.data };
}

export {
    setNavigation,
    addNavigation,
    removeNavigation,
    pushNavigation,
    popNavigation,
    createAdminProp,
    createHomeProp,
    createMessageProp,
    createSettingProp,
    createExploreProp,
    createProfileProp,
    createSearchProp,
    createUserListProp,
    createChatRoomProp,
    createTrendingProp,
    createLegalProp,
    createMessageComposeProp,
};
